// extracted by mini-css-extract-plugin
export default {"APISectionHeader":"APISectionHeader3LN_-QIR0m7x","APISectionHeader-heading":"APISectionHeader-heading4MUMLbp4_nLs"};